import { Box, Card, Tooltip, Typography } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { tokens } from "app/theme";
import { ReactNode } from "react";

export function DashboardCard({
  title,
  children,
  height,
  helpicon,
  helptext
}: {
  title?: string;
  height?: number;
  helpicon?: boolean;
  helptext?: string;
  children: {
    body: ReactNode;
    footer?: ReactNode;
  };
}) {
  return (
    <Card style={{ overflow: "hidden", height: "100%" }}>
      {title ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "12px 14px",
            borderBottom: `1px solid ${tokens.hairline}`,
          }}
        >
          <Typography
            variant="h5"
            style={{ margin: 0, color: tokens.fg1, fontSize: 13 }}
          >
            {title}
          </Typography>
          {helpicon ? (
            <Tooltip title={helptext || ""}>
              <HelpOutlineIcon
                style={{ fontSize: 15, color: tokens.fg3, marginLeft: "auto" }}
              />
            </Tooltip>
          ) : null}
        </div>
      ) : null}
      <div style={{ padding: "14px 16px" }}>
        <Box style={{ height: height ? `${height}px` : undefined }}>
          {children.body}
        </Box>
        {children?.footer ? (
          <Box style={{ marginTop: 12 }}>{children?.footer}</Box>
        ) : null}
      </div>
    </Card>
  );
}
